module.exports = __webpack_public_path__ + "static/media/001.13c3ae2c.jpg";